import styled from 'styled-components'
import { mobileL } from '../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const ResetPassword = styled.div`
  width: 470px;
  ${mobileL({
    width: '100%',
  })};
  header {
    // margin-left: 20px;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 40px;
    ${mobileL({
      flexDirection: 'column',
    })};
    img {
      position: relative;
    }
  }
  h3 {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
  }
  .checklist {
    display: flex;
    align-content: center;
  }
  .isValid {
    color: black;
    font-size: 12px;
  }
  .isInvalid {
    color: #9e9e9e;
    font-size: 12px;
  }
`
